import React from 'react'

import './Loading.scss'

const loading = (props) => (
  <React.Fragment>
    <div className="loading__backdrop"></div>
    <div className="loading__indicator"><div></div></div>
  </React.Fragment>
)

export default loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js